import { request } from '@/shared/api/request'

export const getColContractTerms = (params) => {
	return request({ url: `dict/dColContractDate?shortlist=${params}`, method: 'GET' })
}
